/* eslint-disable */ 
import {useState } from "react";
import { Flex, Text, Icon, useColorModeValue, useToast } from '@chakra-ui/react'; 
import { TbFileInvoice } from 'react-icons/tb';

// Custom components   

import CommonDatatable from 'components/datatable/CommonDatatable';
import Actions from 'views/privado/servicesPostsales/reporteGastos/components/Actions';

import service from 'services/reporteAdministrativoService';

import { 
  createColumnHelper
} from '@tanstack/react-table'
  
type RowObj = {
	fecha: string;
    tipo: string;
    cliente: string;
    numero: number;
    oficina: string;
    expediente: string;
    concepto: string;
    baseImponible: number;
    iVA: number;
    precioTotal: number;
    totalAnticipo: number;
    referenciaCliente: string;
    fechaString: string;
    baseImponibleString: string;
    iVAString: string;
    precioTotalString: string;
    totalAnticipoString: string;
    precioTotalGlobalString: string;
    totalAnticipoGlobalString: string;
};

import { EXPORT_TITLE, EXPORT_DESCRIPTION } from "const/CommonConst";

export default function DataTable() {
	const textColor = useColorModeValue("navy.700", "white");
  const boxBg = useColorModeValue('secondaryGray.300', 'whiteAlpha.100');

  const toast = useToast()

  const [tableData, setTableData] = useState([]);

  const [showEmptyState, setShowEmptyState] = useState(true);
  const [disabledActions, setDisabledActions] = useState(false);
  const [showProgressSearch, setShowProgressSearch] = useState(false);
  const [showProgressExport, setShowProgressExport] = useState(false);
  

  const fetchData = async (cliente:string, fechaInicio:string, fechaFin:string) => {
    return await service.getTabla(cliente, fechaInicio, fechaFin);
  };

  const onChangeFilters = async (selected:any) => {
	try {
		setShowEmptyState(false);
	setDisabledActions(true);
	setShowProgressSearch(true);
	setTableData(await fetchData(selected.cliente, selected.fechaInicio, selected.fechaFin));
}
	finally{
		setDisabledActions(false);
		setShowProgressSearch(false);
	}
  };

  const onExportData = async (selected:any) => {
	try {
	setDisabledActions(true);
	setShowProgressExport(true);
	await service.getExcel(selected.cliente, selected.fechaInicio, selected.fechaFin);
	toast({
		title: EXPORT_TITLE,
		description: EXPORT_DESCRIPTION,
		status: 'success',
		duration: 9000,
		isClosable: true,
	  });
	}
	  finally{
		setDisabledActions(false);
		setShowProgressExport(false);
	  }
  };

    const columnHelper = createColumnHelper<RowObj>();
 	const columns = [
		columnHelper.accessor('fechaString', {
			id: 'fechaString',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
					FECHA FACTURA
				</Text>
			),
			cell: (info: any) => (
        <Text color={textColor} align='left' fontSize='md' fontWeight='500'>
            {info.getValue()}
        </Text>
			)
		}), 
		columnHelper.accessor('tipo', {
			id: 'tipo',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
					TIPO DOC.
				</Text>
			),
			cell: (info) => ( 
        <Text color={textColor} align='left' fontSize='md' fontWeight='500'>
            {info.getValue()}
        </Text>
			)
		}),
		columnHelper.accessor('numero', {
			id: 'numero',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
					NRO. DOC.
				</Text>
			),
			cell: (info) => ( 
        <Text color={textColor} align='left' fontSize='md' fontWeight='500'>
          {info.getValue()}
        </Text>
			)
		}),
		columnHelper.accessor('cliente', {
			id: 'cliente',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
					CLIENTE
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			  </Text>
			)
		}),
		columnHelper.accessor('oficina', {
			id: 'oficina',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
					OFICINA
				</Text>
			),
			cell: (info) => (
        <Text color={textColor} align='left' fontSize='md' fontWeight='500'>
            {info.getValue()}
        </Text>
			)
		}),
		columnHelper.accessor('expediente', {
			id: 'expediente',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        EXPEDIENTE
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}),
		columnHelper.accessor('concepto', {
			id: 'concepto',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        CONCEPTO
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}),
		columnHelper.accessor('baseImponibleString', {
			id: 'baseImponibleString',
			header: () => (
				<Text
					justifyContent='space-between'
					align='right'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        BASE IMPONIBLE
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='right' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}),
		columnHelper.accessor('iVAString', {
			id: 'iVAString',
			header: () => (
				<Text
					justifyContent='space-between'
					align='right'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        I.V.A.
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='right' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		})  ,
		columnHelper.accessor('precioTotalString', {
			id: 'precioTotalString',
			header: () => (
				<Text
					justifyContent='space-between'
					align='right'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        PRECIO TOTAL
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='right' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			),
		}),
		columnHelper.accessor('totalAnticipoString', {
			id: 'totalAnticipoString',
			header: () => (
				<Text
					justifyContent='space-between'
					align='right'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        TOTAL ANTICIPO
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='right' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}),
		columnHelper.accessor('referenciaCliente', {
			id: 'referenciaCliente',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        REFERENCIA CLIENTE
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}) 
	];
	
  return ( 
    <CommonDatatable
    columnsDefinition={columns}
    tableData={tableData}
	showEmptyState={showEmptyState}
	isLoading={disabledActions}
    actionContent={    
        <Actions onChange={onChangeFilters} 
				 onExport={onExportData} 
				 disabledActions={disabledActions} 
				 showProgressExport={showProgressExport} 
				 showProgressSearch={showProgressSearch} /> }

		footerContent={
			tableData.length > 0 ?
			<>
			<Flex direction='column' bg={boxBg} p='16px 20px' borderRadius='14px' mt='15px' ml='auto'>
				<Text fontSize='sm' fontWeight='700' color={textColor}>
				Precio Total:
				</Text>
				<Text fontSize='sm' fontWeight='500' color='secondaryGray.600' textAlign='right'>
				{tableData[0].precioTotalGlobalString}
				</Text>
			</Flex>
			<Flex direction='column' bg={boxBg} p='16px 20px' borderRadius='14px' mt='15px' ml='15px'>
				<Text fontSize='sm' fontWeight='700' color={textColor}>
				Total Anticipo:
				</Text>
				<Text fontSize='sm' fontWeight='500' color='secondaryGray.600' textAlign='right'>
				{tableData[0].totalAnticipoGlobalString}
				</Text>
			</Flex></>
			:  <></>
		}
      />        
  )
} 
